import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

export function initSwiper(el) {
    const id = el.id;
    if (!id || el.swiper) {
        return null;
    }

    return new Swiper('#' + id, {
        modules: [Navigation, Pagination],
        slidesPerView: 'auto',
        spaceBetween: 16,
        grabCursor: true,
        simulateTouch: true,
        touchEventsTarget: 'container',
        observer: true,
        observeParents: true,
        loop: el.dataset.carouselLoop === 'true',
        navigation: {
            nextEl: '.js_carousel__arrow--next[data-carousel="' + id + '"]',
            prevEl: '.js_carousel__arrow--prev[data-carousel="' + id + '"]',
        },
        pagination: {
            el: '.js_carousel__pagination[data-carousel="' + id + '"]',
            clickable: true,
        },
    });
}

document.querySelectorAll('.js_carousel__swiper').forEach(initSwiper);
